import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';
import { linReg } from '../../../../../lib/reduce';

export const COLUMNS_ENTITIES = (t, onSelect, selectedEntities, isDark) => [
    {
        label: '',
        key: 'rank',
        data: 'rank',
        Component: Cell,
        cellSize: 'minmax(50px, 0.5fr)',
        style: (item) => {
            const color = selectedEntities?.includes(item.name)
                ? '#eaf7f7'
                : isDark
                ? '#2a3142'
                : 'white';

            return { background: color };
        },
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <strong className="wripe">
                    <input
                        className="css-e0dnmk"
                        type="checkbox"
                        style={{ marginRight: '10px' }}
                        onChange={() => onSelect(item.name)}
                        checked={selectedEntities?.includes(item.name)}
                        disabled={
                            selectedEntities?.length >= 10 && !selectedEntities?.includes(item.name)
                        }
                    />
                </strong>
            );
        },
    },
    {
        label: t('discover.entities.table.name'),
        key: 'name',
        data: 'name',
        sortType: 'string',
        Component: Cell,
        style: (item) => {
            const color = selectedEntities?.includes(item.name)
                ? '#eaf7f7'
                : isDark
                ? '#2a3142'
                : 'white';
            return { backgroundColor: color };
        },
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <div>
                    <a
                        href={
                            `/domains/${window.info.id}/entities/entity?entities:in=` +
                            encodeURIComponent(data)
                        }
                    >
                        {data}
                    </a>
                </div>
            );
        },
    },
    {
        label: t('discover.entities.table.type'),
        key: 'type',
        data: 'type',
        sortType: 'string',
        Component: Cell,
        style: (item) => {
            const color = selectedEntities?.includes(item.name)
                ? '#eaf7f7'
                : isDark
                ? '#2a3142'
                : 'white';
            return { backgroundColor: color };
        },
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <div style={{ fontSize: '12px', textWrap: 'wrap' }}>{data}</div>;
        },
    },
    {
        label: t('discover.entities.table.pages'),
        key: 'pages',
        data: 'pages',
        Component: Cell,
        style: (item) => {
            const color = selectedEntities?.includes(item.name)
                ? '#eaf7f7'
                : isDark
                ? '#2a3142'
                : 'white';
            return { backgroundColor: color };
        },
    },
    {
        label: t('discover.entities.table.RELEVANCY'),
        key: 'RELEVANCY',
        data: 'RELEVANCY',
        Component: Cell,
        sortType: (array) =>
            array.sort((a, b) => {
                const valueA = a?.salience;
                const valueB = b?.salience;
                return valueA - valueB;
            }),
        style: (item) => {
            const color = selectedEntities?.includes(item.name)
                ? '#eaf7f7'
                : isDark
                ? '#2a3142'
                : 'white';
            return { backgroundColor: color };
        },
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item.salience;

            let c = linReg(item.salienceL);

            return showWithIcon(item.salience, c);
        },
    },
    {
        label: t('discover.entities.table.impressionsL'),
        key: 'impressionsL',
        data: 'impressionsL',
        infoLink: '/support/attributed-impressions',
        info: 'Attributed Impressions is own unique metric to measure entity authority on site. Click on the icon to find out more.',
        Component: Cell,
        style: (item) => {
            const color = selectedEntities?.includes(item.name)
                ? '#eaf7f7'
                : isDark
                ? '#2a3142'
                : 'white';
            return { backgroundColor: color };
        },
        sortType: (array) =>
            array.sort((a, b) => {
                const valueA = a.impressions;
                const valueB = b.impressions;
                return valueA - valueB;
            }),
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return item.impressions;

            let c = linReg(data);

            return showWithIcon(item.impressions, c);
        },
    },
    {
        label: t('discover.entities.table.median_impressions_per_entity'),
        key: 'median_impressions_per_entity',
        data: 'median_impressions_per_entity',
        infoLink: '/support/attributed-impressions',
        info: 'Attributed Impressions is own unique metric to measure entity authority on site. Click on the icon to find out more.',
        Component: Cell,
        style: (item) => {
            const color = selectedEntities?.includes(item.name)
                ? '#eaf7f7'
                : isDark
                ? '#2a3142'
                : 'white';
            return { backgroundColor: color };
        },
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <div>
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            );
        },
    },
    {
        label: t('discover.entities.table.ctr'),
        key: 'ctr',
        data: 'ctr',
        Component: Cell,
        style: (item) => {
            const color = selectedEntities?.includes(item.name)
                ? '#eaf7f7'
                : isDark
                ? '#2a3142'
                : 'white';
            return { backgroundColor: color };
        },
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;

            let c = linReg(item.ctrL);
            return showWithIcon(data, c);
        },
    },
];

function showWithIcon(value, c) {
    const className = value < 0 ? 'table-text-danger' : 'table-text-success';

    return (
        <div className="d-flex gap-8">
            <div>{numeral(value).format('0.00')}</div>
            <div className={`${className} d-flex gap-4`}>
                {value < 0 ? <i className="icon-down" /> : <i className="icon-up" />}
                {numeral(Math.abs(c.slope)).format('0.0')}%
            </div>
        </div>
    );
}
